export default {
  path: '/home/withdraw-approval-whitelist',
  component: () => import('./index.vue'),
};
